// action - state management
import * as actionTypes from '../actions';

const initialState = {
    initialized: false,
    config: null,
    active: null,
    available: [],
    clients: []
};

// ===========================|| PRODUCTS REDUCER ||=========================== //

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.INITIALIZE_ACCOUNT: {
          console.log("Initializing Account...", action.payload);

          // Update state
          return {
              ...state,
              initialized: true,
              config: action.payload.config,
              clients: action.payload.clients
          };
        }
        case actionTypes.UPDATE_ACCOUNT: {
            console.log("Setting Active Client...", action.payload);
  
            // Update state
            return {
                ...state,
                active: action.payload.active,
                available: action.payload.available
            };
          }
        default:
            return state;
    }
};

export default accountReducer;